import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
var CLOSE_MODE = /* @__PURE__ */ ((CLOSE_MODE2) => {
  CLOSE_MODE2["DEFAULT"] = "default";
  CLOSE_MODE2["SCRIPT"] = "script";
  CLOSE_MODE2["CLOSE"] = "close";
  return CLOSE_MODE2;
})(CLOSE_MODE || {});
let currentCloseMode = "default";
function setCloseMode(mode) {
  currentCloseMode = mode;
}
function getCloseMode() {
  return currentCloseMode;
}
function showNavigationClose() {
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_CLOSE,
    parameters: {
      type: "close"
      /* CLOSE */
    }
  }).then((res) => {
    if (res.success) {
      setCloseMode(
        "close"
        /* CLOSE */
      );
    }
    return res;
  });
}
function setNavigationCloseDefault() {
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_CLOSE,
    parameters: {
      type: "default"
      /* DEFAULT */
    }
  }).then((res) => {
    if (res.success) {
      setCloseMode(
        "default"
        /* DEFAULT */
      );
    }
    return res;
  });
}
function setNavigationCloseEvent(callback) {
  if (typeof window === "undefined") {
    console.warn("setCloseEvent can't be listened on node environement.");
    return;
  }
  window.KakaoPay.webNavigationClose = function() {
    console.log("[setCloseEvent] webNavigationClose called");
    callback && callback();
  };
  return exec({
    command: INTERFACE.CUSTOM_NAVIGATION_CLOSE,
    parameters: {
      type: "script"
      /* SCRIPT */
    }
  }).then((res) => {
    if (res.success) {
      setCloseMode(
        "script"
        /* SCRIPT */
      );
    }
    return res;
  });
}
export {
  CLOSE_MODE,
  getCloseMode,
  setNavigationCloseDefault,
  setNavigationCloseEvent,
  showNavigationClose
};
